<template>
  <div class="content-warp paddingtb20">
    <div class="plate-three main-width">
      <div class="match-sub-title">{{$t('竞赛项目')}}</div>
      <div class="content">
        <a-collapse
          :default-active-key="'0_a'"
          :bordered="false"
        >
          <template #expandIcon="props">
            <a-icon
              type="caret-right"
              :rotate="props.isActive ? 90 : 0"
            />
          </template>
          <a-collapse-panel
            :key="index+'_a'"
            :header="item.combatName"
            v-for="(item,index) in queryMatchCombat"
          >
            <div class="table-matchCombatMesVOS">
              <div
                class="row"
                v-for="(item1,index1) in item.combatData"
                :key="index1+'m_v'"
              >
                <div class="left">
                  <p>{{item1.title||'未知'}}</p>
                  <p>({{(item1.minAge||'').slice(0,10)}}至{{(item1.maxAge||'').slice(0,10)}})</p>
                </div>
                <div class="right">
                  <div
                    class="row"
                    v-if="item1.sexData['man'] && item1.sexData['man'].length>0"
                  >
                    <span class="title">男子组</span>
                    <span class="text">
                      <span v-for="(it,index) in item1.sexData['man']" :key="index">{{it.weight||''}}<span v-if="index + 1 < item1.sexData['man'].length">，</span></span>
                    </span>
                </div>
                <div
                  class="row"
                  v-if="item1.sexData['unisex'] && item1.sexData['unisex'].length>0"
                >
                  <span class="title">不分性别</span>
                  <span class="text">
                    <span v-for="(it,index) in item1.sexData['unisex']" :key="index">{{it.weight||''}}<span v-if="index + 1 < item1.sexData['unisex'].length">，</span></span>
                  </span>
            </div>
            <div
              class="row"
              v-if="item1.sexData['woman'] && item1.sexData['woman'].length>0"
            >
              <span class="title">女子组</span>
              <span class="text">
                <span v-for="(it,index) in item1.sexData['woman']" :key="index">{{it.weight||''}}<span v-if="index + 1 < item1.sexData['woman'].length">，</span></span>
              </span>
      </div>
    </div>
  </div>
  </div>
  </a-collapse-panel>
  </a-collapse>
  </div>
  </div>
  <!--竞赛项目-->
  </div>
</template>

<script>
export default {
  name: 'MatchProject',
  components: {},
  created () {
    this.initData()
  },
  destroyed () {},
  mounted () {
  },
  data () {
    return {
      queryMatchCombat: [],
      matchId: this.$route.query.matchId
    }
  },
  methods: {
    initData () {
      this.$api.match.queryMatchCombat({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.queryMatchCombat = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-width {
  width:1200px;
  margin-left:auto;
  margin-right:auto;
}
.content-warp {
  background-color: #f7f7f7;
}
.match-sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #232323;
  line-height: 40px;
}
.plate-one {
  display: flex;
  flex-direction: row;
  .row-framework,
  .row-apply {
    flex: 1;
    .content {
      height: 200px;
    }
  }
  .row-framework {
    margin-right: 20px;
    .content {
      background-color: #fff;
    }
    .s-content {
      padding: 5px 20px;
    }
  }
  .row-apply {
    margin-left: 20px;
    .content {
      display: flex;
      flex-direction: row;
    }
    .time {
      flex: 2;
      margin-right: 40px;
      background-color: #fff;
      .count-down {
        text-align: center;
        color: #fff;
        display: block;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }
      span {
        font-size: 16px;
        font-weight: bold;
      }
      .time-content {
        color: #000;
        padding: 0 15px;
        p {
          display: block;
          height: 45px;
          line-height: 45px;
        }
      }
    }
    .qr-code {
      background-color: #fff;
      flex: 1;
      display: flex;
      flex-direction: column;
      .code-title {
        background-color: #434343;
        height: 40px;
        line-height: 40px;
        color: #fff;
        text-align: center;
      }
      .img-code {
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 120px;
          height: 120px;
        }
      }
    }
  }
}
.plate-two {
  padding: 20px 0;
  margin-top: 40px;
  background-color: #fff;
  .content {
    min-height: 100px;
    background-color: #f1f1f1;
  }
}
.plate-three {
  padding: 20px 0;
  .content {
    min-height: 100px;
    background-color: #fff;
    .table-matchCombatMesVOS {
      border: 1px solid #ccc;
    }
    .row {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ccc;
      &:last-child {
        border-bottom: none;
        .right .row {
          &:last-child {
            border-bottom: none !important;
          }
        }
      }
      .left {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 80px;
        border-right: 1px solid #ccc;
        width: 25%;
        text-align: center;
        background-color: #f1f1f1;
      }
      .right {
        width: 75%;
        height: 80px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .row {
          flex: 1;
          width: 100%;
          // height: 40px;
          text-align: center;
          border-bottom: 1px solid #ccc;
          &:last-child {
            border-bottom: none;
          }
          .title {
            flex-shrink: 0;
            width: 100px !important;
            height: 100%;
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #ccc;
          }
          .text {
            padding: 0 15px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchProject.vue